import "../../assets/stylesheets/realestate.css";
import React, {useContext, useEffect, useMemo, useState} from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Logo from "../../assets/image/logo.svg";
import FilterPane from "./FilterPane";
import EstateList from "./EstateList";
import {ContactInfoContext} from "../additional/ContactInfoContext";

function Search() {
    const location = useLocation();
    const { t, i18n } = useTranslation(["home", "estate"]);
    const { contactInfo } = useContext(ContactInfoContext);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const newFilter = new Map();
        let newQuery = "";
        queryParams.forEach((value, key) => {
            if (key === "query") {
                newQuery = value;
            } else {
                newFilter.set(key, value.split(",").map(item => item.trim()));
            }
        });

        console.log("Updated filter from URL:", [...newFilter.entries()], "Query:", newQuery);
        setFilter(newFilter);
        setQuery(newQuery);
    }, [location.search]);

    const [filter, setFilter] = useState(new Map());
    const [query, setQuery] = useState("");

    return (
        <>
            <Helmet>
                <meta name="description" content={t("searchDescribe", { defaultValue: "Search for properties on SIEVN Real Estate Agency" })} />
                <link rel="canonical" href={`https://sievn.am/${i18n.language}/search`} />
                <title>{t("searchTitle", { defaultValue: "Search Properties" })}</title>
                <meta property="og:title" content={t("searchTitle", { defaultValue: "Search Properties" })} />
                <meta property="og:site_name" content="sievn.am" />
                <meta property="og:url" content={`https://sievn.am/${i18n.language}/search`} />
                <meta property="og:description" content={t("searchDescribe", { defaultValue: "Search for properties on SIEVN Real Estate Agency" })} />
                <meta property="og:image" content={Logo} />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
            </Helmet>

            <section className="homepage">
                <div className="home__hero">
                    <img src={contactInfo.homeUrl} alt="Hero background" className="home__hero-image" />
                    <div className="home__hero-overlay">
                        <div className="home__hero-content">
                            <h1 className="home__hero-text2">{t("company-name")}</h1>
                            <h2 className="home__hero-text3">{t("comfort-text")}</h2>
                        </div>
                    </div>
                </div>
                <div className="home__top-estates">
                    {/*<div className="filter__pane">*/}
                    {/*    <FilterPane*/}
                    {/*        type="search"*/}
                    {/*        language={i18n.language}*/}
                    {/*        onFilterChange={(newFilter) => {*/}
                    {/*            console.log("Search: FilterPane onFilterChange:", [...newFilter.entries()]);*/}
                    {/*            setFilter(new Map(newFilter));*/}
                    {/*        }}*/}
                    {/*        initialFilter={filter}*/}
                    {/*    />*/}
                    {/*</div>*/}
                    <EstateList type="search" language={i18n.language} filter={filter} query={query} />
                </div>
            </section>
        </>
    );
}

export default Search;